// eslint-disable-next-line no-unused-vars
import { get, getInfo, postInfo } from '@/utils/apiBase.js';

// 获取收款账户
const getValidBankAccountList = (option) => {
  return get('/apis/userauth/valid_bank_account_list', option);
};

//收款账号列表
const accountList = (option) => {
  return postInfo('/apis/userauth/account/list', option);
};
// 绑卡
const accountAdd = (option) => {
  return postInfo('/apis/userauth/account/add', option);
};
//获取认证
const accountInfo = (option) => {
  return postInfo('/apis/userauth/auth/info', option);
};
//绑卡用户鉴权
const accountCheck = (option) => {
  return postInfo('/apis/userauth/account/check', option);
};
//解绑
const accountUnbind = (option) => {
  return postInfo('/apis/useraccount/unbinding', option);
};

//申请开票
const mdApply_ticket = (option) => {
  return postInfo('/apis/settlement/md/apply_ticket', option);
};
// 开票详情
const mdTicket_info = (option) => {
  return getInfo('/apis/settlement/md/ticket_info', option);
};
// cp开票管理
const mdTicket_manager = (option) => {
  return getInfo('/apis/settlement/md/ticket_manager', option);
};
// 查询自己的认证信息
const getAuthInfo = (option) => {
  return getInfo('/apis/userauth/query/info', option);
};
export default {
  getValidBankAccountList,
  accountList,
  accountAdd,
  accountInfo,
  accountCheck,
  accountUnbind,
  mdApply_ticket,
  mdTicket_info,
  mdTicket_manager,
  getAuthInfo
};
